// Unified analytics wrapper: GA4 + Yandex.Metrika
// Every user event is mirrored to both systems in one call.

export const GA_MEASUREMENT_ID = "G-C0M850R91H";
export const YM_COUNTER_ID = 111581617;

// Map GA4 event names -> Yandex.Metrika goal identifiers (uppercase)
const YM_GOAL_MAP = {
  whatsapp_click: "WHATSAPP_CLICK",
  app_click: "APP_CLICK",
  phone_click: "PHONE_CLICK",
  hello_landing_view: "HELLO_VIEW",
  ai_fitting_start: "AI_FITTING_START",
};

const hasGtag = () => typeof window !== "undefined" && typeof window.gtag === "function";
const hasYm = () => typeof window !== "undefined" && typeof window.ym === "function";

export const trackEvent = (name, params = {}) => {
  // Google Analytics 4
  if (hasGtag()) {
    try {
      window.gtag("event", name, params);
    } catch (_) {
      /* fail silently */
    }
  }
  // Yandex.Metrika goal
  if (hasYm()) {
    const goal = YM_GOAL_MAP[name];
    if (goal) {
      try {
        window.ym(YM_COUNTER_ID, "reachGoal", goal, params);
      } catch (_) {
        /* fail silently */
      }
    }
  }
};

export const trackPageView = (path) => {
  const url = window.location.origin + path;
  // Google Analytics 4
  if (hasGtag()) {
    try {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    } catch (_) {
      /* fail silently */
    }
  }
  // Yandex.Metrika SPA hit
  if (hasYm()) {
    try {
      window.ym(YM_COUNTER_ID, "hit", url, {
        title: document.title,
        referer: document.referrer,
      });
    } catch (_) {
      /* fail silently */
    }
  }
};
